import { render, staticRenderFns } from "./BiddingMemberComponent.vue?vue&type=template&id=58755759"
import script from "./BiddingMemberComponent.vue?vue&type=script&lang=js"
export * from "./BiddingMemberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports